import React from 'react';
import EntityDetails from '../common/EntityDetails';
import services from '../../services';
import queryString from 'query-string'



class ContaTabs extends React.Component {

  constructor() {
    super()

    this.state = {
        data: null,
        loaded: false,
        estado: "",
        mencoescomplementares:"",
        mencoesQuinta: "",
        mencoesCasta : "",
        outrasMencoes: "",
      }

  }

  componentDidMount() {
    const filters = { entityId: queryString.parse(this.props.search).entityId };
    const estado = queryString.parse(this.props.search).estado;

    var IDConta = Number(queryString.parse(this.props.search).accountId);

    if (isNaN(IDConta)) {
        IDConta = 0;
    }

    const numFilters = { entityId: queryString.parse(this.props.search).IDInstalacaoVinica, accountId: IDConta };
    (async () => {
      const details = await Promise.all([
        services.apiCall.requestApi("Revenue/getEntityDetail", filters, 'post'),
        services.apiCall.requestApi("ContaCorrente/GetDetalheTabs", numFilters, 'post')
      ]);
      if (details && details.length) {
        const data = details.reduce((acc, val) => ({ ...acc, ...val }), {})
        this.setState({ data, loaded: true },()=>{
          if(this.props.entityDetailData){
            this.props.entityDetailData(this.state.data)
          }
          this.state.estado = estado;
        })
      }
    })();
    /*menções complementares*/
    (async () => {
        
        const mencoescomplementares = (this.props.search).mencoescomplementares;
        const filterConta = {idContaCorrente: IDConta}
        if(IDConta != 0){
        const details = await Promise.all([
            services.apiCall.requestApi("ContaCorrente/GetMencoesComplementares", filterConta, 'get')
        ]);
            this.state.mencoescomplementares = details;
        // this.setState({ mencoescomplementares })
        // if (details && details.length) {
        //     const data = details.reduce((acc, val) => ({ ...acc, ...val }), {})
        //     this.setState({ data, loaded: true },()=>{
        //     if(this.props.entityDetailData){
        //         this.props.entityDetailData(this.state.data)
        //     }
        //     this.state.mencoescomplementares += mencoescomplementares;
        //     })
        // }
        
    console.log(details, "são as meções obj");
    var mencoesQuinta = "";
    var mencoesCasta = "";
    var outrasMencoes = "";
    var mencoesDesignacao = [];
    
        if(details[0] != undefined){
        if(details[0].mencoesQuinta.length != 0){
            for (let index = 0; index < details[0].mencoesQuinta.length; index++) {
            if (index == details[0].mencoesQuinta.length - 1) {
                mencoesQuinta += details[index].mencoesQuinta[index].designacao;
            } else {
                mencoesQuinta += details[index].mencoesQuinta[index].designacao + ', ';
            }
            }
            
        }else{
            mencoesQuinta = "NA"
        }

        if(details[0].mencoesCasta.length != 0){
            for (let index = 0; index < details[0].mencoesCasta.length; index++) {
                if (index == details[0].mencoesCasta.length - 1) {
                    mencoesCasta += details[index].mencoesCasta[index].designacao;
                } else {
                    mencoesCasta += details[index].mencoesCasta[index].designacao + ', ';
                }
            }
         
        }else{
            mencoesCasta = "NA"
        }

        if(details[0].outrasMencoes.length != 0){
            for (let index = 0; index < details[0].outrasMencoes.length; index++) {
                if (index == details[0].outrasMencoes.length - 1) {
                    outrasMencoes += details[index].outrasMencoes[index].mencaoComplementar;
                } else {
                    outrasMencoes += details[index].outrasMencoes[index].mencaoComplementar + ', ';
                }
            } 
        }else{

            outrasMencoes = "NA"
        }
    }
    else{
        mencoesQuinta = "NA"
        mencoesCasta = "NA"
        outrasMencoes = "NA"
    }
    console.log(mencoesDesignacao , "isto são as menções")

    this.setState({
        mencoesQuinta,
        mencoesCasta,
        outrasMencoes,
        mencoesDesignacao
    });

    console.log(this, "this")
      }
    })()
  }

  componentDidUpdate(prevProps){
    if(prevProps.date !== this.props.date) {
        const filters = { entityId: queryString.parse(this.props.search).entityId };
        const estado = queryString.parse(this.props.search).estado;

        var IDConta = Number(queryString.parse(this.props.search).accountId);

        if (isNaN(IDConta)) {
            IDConta = 0;
        }

        const numFilters = { entityId: queryString.parse(this.props.search).IDInstalacaoVinica, accountId: IDConta };
        (async () => {
        const details = await Promise.all([
            services.apiCall.requestApi("Revenue/getEntityDetail", filters, 'post'),
            services.apiCall.requestApi("ContaCorrente/GetDetalheTabs", numFilters, 'post')
        ]);
        if (details && details.length) {
            const data = details.reduce((acc, val) => ({ ...acc, ...val }), {})
            this.setState({ data, loaded: true },()=>{
            if(this.props.entityDetailData){
                this.props.entityDetailData(this.state.data)
            }
            this.state.estado = estado;
            })
        }
        })();
    }
  }

  render() {
    if (!this.state.loaded) {
      return null;
    }

    const { data } = this.state;
    const {accountDetails} = this.props;

    

    return (
        <>
        {
            this.props.screen === "movements" && 
            <>
                <div className="tab-section">
                    <div className="row">
                        <div className="col-6">
                            <div className="innerBox">
                                <div className="row no-gutter">
                                    <div className="col-7">
                                        <p>Entidade</p>
                                        <p className="font-weight-bold">{ !!data && !!data.busEntidade && data.busEntidade.nome }</p>
                                    </div>
                                    <div className="col-5">
                                        <p>Instalação Vínica</p>
                                        <p className="font-weight-bold">{ !!data && data.wineInhalation ? data.wineInhalation : "NA" }</p>
                                    </div>
                                    <div className="col-3">
                                        <p>Número de Registo</p>
                                        <p className="font-weight-bold">{ !!data && !!data.numeroRegisto && data.numeroRegisto ? data.numeroRegisto : "NA" }</p>
                                    </div>
                                    <div className="col-2">
                                        <p>Ano do Produto</p>
                                        <p className="font-weight-bold">{ !!data && data.anoProduto ? data.anoProduto : 0 }</p>
                                    </div>
                                    <div className="col-2">
                                        <p>Cor</p>
                                        <p className="font-weight-bold">{ !!data && data.cor ? data.cor : "NA"}</p>
                                    </div>
                                    <div className="col-5">
                                        <p>Menção Qualitativa</p>
                                        <p className="font-weight-bold">{ !!data && data.mencaoObrigatoria ? data.mencaoObrigatoria : "NA"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="innerBox">
                                <div className="row no-gutter">
                                    <div className="col-3">
                                        <p>Tipo de Conta</p>
                                        <p className="font-weight-bold">{ accountDetails.tipoConta }</p>
                                    </div>
                                    <div className="col-3">
                                        <p>Produto</p>
                                        <p className="font-weight-bold">{ accountDetails.accountProduct }</p>
                                    </div>
                                    <div className="col-3">
                                        <p>Estado</p>
                                        <p className="font-weight-bold">{ this.state.estado}</p>
                                    </div>
                                    <div className="col-3">
                                            <div>
                                                <p>{!this.props.screen ? "Saldo na Instalação" : "Saldo atual da conta"}</p>
                                                <h4>{ this.props.accountDetails && this.props.accountDetails["accountTotal"] ? 
                                                services.money.format(this.props.accountDetails["accountTotal"]) : 
                                                !!data && services.money.format(data.current_balance)} L</h4>
                                            </div>
                                            {this.props.screen !== "movements" && 
                                                <>
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            <p>{"Granel Não cert"}</p>
                                                            <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoGranel"] ? 
                                                        this.props.accountDetails["saldoGranel"] : !!data && data.saldoGranel ? services.money.format(data.saldoGranel) : "0"}</p>
                                                        </div>
                                                        <div>
                                                            <p>{"Granel Apto"}</p>
                                                            <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoGranelApto"] ? 
                                                        this.props.accountDetails["saldoGranelApto"] : !!data && data.saldoGranelApto ? services.money.format(data.saldoGranelApto) : "0"}</p>
                                                        </div>
                                                        <div>
                                                            <p>{"Indisp Granel"}</p>
                                                            <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoIndispGranel"] ? 
                                                        this.props.accountDetails["saldoIndispGranel"] : !!data && data.saldoIndispGranel ? services.money.format(data.saldoIndispGranel) : "0"}</p>
                                                        </div>
                                                        <div>
                                                            <p>{"Indisp Engarrafado"}</p>
                                                            <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoIndispEngarrafado"] ? 
                                                        this.props.accountDetails["saldoIndispEngarrafado"] : !!data && data.saldoIndispEngarrafado ? services.money.format(data.saldoIndispEngarrafado) : "0"}</p>
                                                        </div>
                                                        <div>
                                                            <p>{"Produto Acabado"}</p>
                                                            <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoProdutoAcabado"] ? 
                                                        this.props.accountDetails["saldoProdutoAcabado"] : !!data && data.saldoProdutoAcabado ? services.money.format(data.saldoProdutoAcabado) : "0"}</p>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col-6 barraMencoes"  >
                            <div className="innerBox">
                                <div className="row no-gutter">
                                    <div className="col-6">
                                        <p>Quinta</p>
                                        <p className="font-weight-bold">{this.state.mencoesQuinta}</p>
                                    </div>
                                    <div className="col-6">
                                        <p>Casta</p>
                                        <p className="font-weight-bold">{this.state.mencoesCasta}</p>
                                    </div>
                                    <div className="col-12">
                                        <p>Outras Menções</p>
                                        <p className="font-weight-bold">{this.state.outrasMencoes}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {
                            (!this.props.screen || !this.props.screen === "movements") &&
                                <div className="innerBox">
                                    <p>Saldo total:</p>
                                    <h4>{ !!data && services.money.format(data.current_balance)}</h4>
                                </div>
                        } */}
                    
                    </div>
                </div>
            </>
        }
        {this.props.screen !== "movements" && 
                                                <>
        <div className="tab-section">
            <div className="row">
            <div className="col-3">
                <div className="innerBox">
                <p>Entidade</p>
                <p className="font-weight-bold">{ !!data && !!data.busEntidade && data.busEntidade.nome }</p>
                </div>
            </div>
            <div className="col-5">
                <div className="innerBox">
                <div className="row no-gutter">
                    <div className="col-4">
                    <p>Instalação Vínica Selecionada:</p>
                    <p className="font-weight-bold">{ !!data && data.wineInhalation ? data.wineInhalation : "NA" }</p>
                    </div>
                    <div className="col-4">
                    <p>Morada Instalação:</p>
                    <p className="font-weight-bold">{ !!data && data.inhalationAddress ? data.inhalationAddress : "NA"}</p>
                    </div>
                    <div className="col-4">
                    <p>Entreposto Instalação:</p>
                    <p className="font-weight-bold">{ !!data && data.nomeEntreposto ? data.nomeEntreposto : "NA"}</p>
                    </div>
                </div>
                </div>
            </div>
            {
                // (!this.props.screen || !this.props.screen === "movements") &&
                <div className="col">
                    <div className="innerBox">
                        <div>
                            <p>{!this.props.screen ? "Saldo na Instalação" : "Saldo atual da conta"}</p>
                            <h4>{ this.props.accountDetails && this.props.accountDetails["accountTotal"] ? 
                            services.money.format(this.props.accountDetails["accountTotal"]) : 
                            !!data && services.money.format(data.current_balance)} L</h4>
                        </div>
                        {this.props.screen !== "movements" && 
                            <>
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <p>{"Granel Não Cert"}</p>
                                        <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoGranel"] ? 
                                    this.props.accountDetails["saldoGranel"] : !!data && data.saldoGranel ? services.money.format(data.saldoGranel) : "0"}</p>
                                    </div>
                                    <div>
                                        <p>{"Granel Apto"}</p>
                                        <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoGranelApto"] ? 
                                    this.props.accountDetails["saldoGranelApto"] : !!data && data.saldoGranelApto ? services.money.format(data.saldoGranelApto) : "0"}</p>
                                    </div>
                                    <div>
                                        <p>{"Indisp Granel"}</p>
                                        <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoIndispGranel"] ? 
                                    this.props.accountDetails["saldoIndispGranel"] : !!data && data.saldoIndispGranel ? services.money.format(data.saldoIndispGranel) : "0"}</p>
                                    </div>
                                    <div>
                                        <p>{"Indisp Engarrafado"}</p>
                                        <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoIndispEngarrafado"] ? 
                                    this.props.accountDetails["saldoIndispEngarrafado"] : !!data && data.saldoIndispEngarrafado ? services.money.format(data.saldoIndispEngarrafado) : "0"}</p>
                                    </div>
                                    <div>
                                        <p>{"Produto Acabado"}</p>
                                        <p className="font-weight-bold">{this.props.accountDetails && this.props.accountDetails["saldoProdutoAcabado"] ? 
                                    this.props.accountDetails["saldoProdutoAcabado"] : !!data && data.saldoProdutoAcabado ? services.money.format(data.saldoProdutoAcabado) : "0"}</p>
                                    </div>
                                </div>
                            </>
                        }
                        
                        
                    </div>
                </div>
            }

            </div>
        </div>
        </>
        }
      </>
    )
  }

}

export default ContaTabs;
